<template>
  <div class="fts-listing-column-design">
    <div class="listing-column">
      <fts-dropdown-select
        append-to-body
        append-content-class="dropdown-menu"
        class="listing-column-action listing-wrapper-handle"
        @selected="selectMenuAction"
      >
        <fts-tippy slot="toggle">
          <font-awesome-icon 
            :icon="['fas', 'grip-vertical']"
            fixed-width
            class="listing-column-action-toggle listing-column-action-toggle--grab"
          />
          <template #content>
            <div class="tippy-hint">
              <span class="tippy-hint-highlight">Drag</span> to move
            </div>
            <div class="tippy-hint">
              <span class="tippy-hint-highlight">Click</span> to open menu
            </div>
          </template>
        </fts-tippy>
        <template #menu="{ select }">
          <div
            class="dropdown-option"
            @click="select('configure')"
          >
            <div class="dropdown-option-icon">
              <font-awesome-icon :icon="['fas', 'cog']" fixed-width />
            </div>
            <div>Configure</div>
          </div>
          <div class="dropdown-option" @click="select('remove')">
            <div class="dropdown-option-icon">
              <font-awesome-icon :icon="['fas', 'times']" fixed-width />
            </div>
            <div>Remove</div>
          </div>
        </template>
      </fts-dropdown-select>

      <div class="listing-column-info">
        <fts-label-group
          :item="formData"
          information
        />
      </div>

      <fts-form-design-shortcut
        :modules="modules"
        :options="options"
        :selected-options="selectedOptions"
        disable-create
        class="listing-column-action"
        @option:selected="(option) => $emit('shortcut-option:selected', option)"
      >
        <fts-tippy>
          <font-awesome-icon
            :icon="['fas', 'plus']"
            fixed-width
            class="listing-column-action-toggle"
          />
          <div slot="content" class="tippy-hint">
            <span class="tippy-hint-highlight">Click</span> to add a field
          </div>
        </fts-tippy>
      </fts-form-design-shortcut>
    </div>

    <fts-listing-design
      :modules="modules"
      :options="Array.isArray(formData.fields) && formData.fields.filter((x) => x.hide)"
      :selected-options="Array.isArray(formData.fields) && formData.fields.filter((x) => !x.hide)"
      :list.sync="formData.fields"
      is-table-columns
      class="listing-column-table"
      v-if="formData.type == 14"
    />
  </div>
</template>

<script>
import Vue from 'vue';

import FTSTippy from '../elements/FTSTippy';
import FTSDropdownSelect from '../elements/FTSDropdownSelect';
import FTSLabelGroup from '../elements/FTSLabelGroup';
import FTSFormDesignShortcut from './FTSFormDesignShortcut';
import FTSListingDesign from './FTSListingDesign.vue';

export default {
  components: {
    "fts-tippy": FTSTippy,
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-label-group": FTSLabelGroup,
    "fts-form-design-shortcut": FTSFormDesignShortcut
  },
  props: {
    modules: Array,
    options: Array,
    selectedOptions: Array,
    formData: Object
  },
  methods: {
    selectMenuAction(action) {
      if (action === 'configure') {
        if (this.formData.id === 'action') {
          this.$emit('action:manage', this.formData);
        }
      } else if (action === 'remove') {
        this.$emit('option:remove', this.formData);
      }
    }
  },
  beforeCreate() {
    Vue.component("fts-listing-design", FTSListingDesign);
  }
}
</script>

<style lang="scss" scoped>
.fts-listing-column-design {
  padding: 0.5rem 0.25rem;
  font-size: 0.875rem;
  line-height: 1.5;
  &:hover {
    > .listing-column > .listing-column-action {
      visibility: visible;
    }
  }
  .listing-column {
    display: flex;
  }
  .listing-column-action {
    visibility: hidden;
    .listing-column-action-toggle {
      font-size: 0.75rem;
      color: var(--fts-default);
      &.listing-column-action-toggle--grab {
        cursor: grab;
      }
    }
  }
  .listing-column-info {
    margin-left: 0.375rem;
    margin-right: 0.375rem;
    min-width: 0;
  }
  .listing-column-table {
    margin-top: 0.5rem;
    margin-left: -0.25rem;
  }
}
</style>